import { render, staticRenderFns } from "./card-rights.vue?vue&type=template&id=2f9f6a1e&scoped=true&"
import script from "./card-rights.vue?vue&type=script&lang=js&"
export * from "./card-rights.vue?vue&type=script&lang=js&"
import style0 from "./card-rights.vue?vue&type=style&index=0&id=2f9f6a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f6a1e",
  null
  
)

export default component.exports